var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visibleNotifications.length ? _c('div', {
    staticClass: "notification-banner",
    attrs: {
      "id": "notification-banner"
    }
  }, _vm._l(_vm.visibleNotifications, function (notification) {
    return _c('b-alert', {
      key: notification.id,
      staticClass: "notification",
      attrs: {
        "id": 'notification-' + notification.id,
        "variant": "warning",
        "dismiss-label": _vm.$t('notification.dismiss'),
        "show": "",
        "dismissible": ""
      },
      on: {
        "dismissed": function dismissed($event) {
          return _vm.markRead(notification);
        }
      }
    }, [_c('b-icon-info-circle', {
      staticClass: "mr-2"
    }), notification.title ? _c('strong', {
      staticClass: "notification-title"
    }, [_vm._v(_vm._s(notification.title))]) : _vm._e(), _c('span', {
      staticClass: "notification-text"
    }, [_vm._v(_vm._s(notification.text))])], 1);
  }), 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }